import { getJBPPartnerBasicInfoCrud } from './getJBPPartnerBasicInfoCrud'

export const getJBPPartnerBasicInfoCrudWithKey = (pid: string, fYear: number) => {
  return getJBPPartnerBasicInfoCrud(['PartnerId', pid, 'FYear', fYear].join(','))
}
